import _ from "lodash";
import { getIn } from "formik";
import PropTypes from "prop-types";
import React from "react";

import { createClassNameString } from "@/utils/createClassNameString";

import { FormFieldError } from "../FormFieldError/FormFieldError";
import { Input } from "../../Input";

import "../styles.scss";

export const FormTextInput = ({
  className,
  customError,
  formikProps,
  inputClassName,
  name,
  placeholder,
  subTitle,
  testId,
  title,
  // normally form fields do not error until after submission
  // because they have not been touched
  // setting this to true triggers the error after editing
  // for the first time
  triggerErrorOnChange = false,
  // only use props to pass in native html input props
  ...props
}) => {
  const errorMessage = getIn(formikProps.errors, name);
  const isTouched = getIn(formikProps.touched, name);
  const value = _.get(formikProps.values, name);

  const handleChange = async (event) => {
    await formikProps.setFieldValue(name, event.target.value);
    if (!isTouched && triggerErrorOnChange) {
      await formikProps.setFieldTouched(name, true);
    }
  };

  return (
    <div className={createClassNameString(["FormField-container", className])}>
      {(title || subTitle) && (
        <div className="FormField-header_container" data-public>
          {title && <h3 className="FormField-title">{title}</h3>}
          {subTitle && <h3 className="FormField-subTitle">{subTitle}</h3>}
        </div>
      )}

      <div>
        <Input
          error={isTouched && errorMessage}
          ignoreEnterSubmit={true}
          inputClassName={createClassNameString(["FormTextInput-input", inputClassName])}
          onChange={handleChange}
          placeholder={placeholder}
          testId={testId}
          value={value}
          {...props}
        />

        {!customError && errorMessage && isTouched && (
          <FormFieldError>{errorMessage}</FormFieldError>
        )}

        {/* lets the dev pick what is displayed below the text area */}
        {customError && customError(value, errorMessage, isTouched)}
      </div>
    </div>
  );
};

FormTextInput.propTypes = {
  className: PropTypes.string,
  customError: PropTypes.func,
  formikProps: PropTypes.object,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  props: PropTypes.object,
  subTitle: PropTypes.string,
  testId: PropTypes.string,
  title: PropTypes.string,
  triggerErrorOnChange: PropTypes.bool,
};
